<template lang="pug">
  .b-connectors-area
    svg(
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
    )
      defs
        marker#arrowHeadLeftX(
          :viewBox="arrowParams.viewBox"
          refX="0"
          :refY="arrowParams.width"
          :markerWidth="arrowParams.width"
          :markerHeight="arrowParams.width"
          orient="auto-start-reverse"
        )
          path(
            :d="arrowParams.path"
            fill="black"
          )
        marker#arrowHeadRightX(
          :viewBox="arrowParams.viewBox"
          refX="0"
          :refY="arrowParams.width"
          :markerWidth="arrowParams.width"
          :markerHeight="arrowParams.width"
          orient="auto-start-reverse"
        )
          path(
            :d="arrowParams.path"
            fill="black"
          )
      g(
        v-for="(item, index) in itemsConnectors"
        :key="item.id"
        v-if="item.connectorParams"
        :id="item.id"
      )
        path(
          fill="none"
          :style="pathStyle(item)"
          :d="path(item)"
          @mouseover="hoveredItem = item.from"
          @mouseleave="hoveredItem = false"
          @click="showAddMenu(item)"
          :draggable="isOverlay"
          @drop="drop"
          :marker-start="!isOverlay && item.returnToParent && 'url(#arrowHeadLeftX)'"
          :marker-end="!isOverlay && 'url(#arrowHeadRightX)'"
        )
</template>

<script>
import drag from '@/mixims/drag';
import ArrowHeadSVG from '@/components/icons/ArrowHeadSVG';
import { mapFields } from 'vuex-map-fields';
import { eventBus } from '@/common/eventBus';

const ADJUST_CURVE_MAX = 32;
const ARROW_W = 7;

export default {
  name: 'ConnectorsSVG',
  mixins: [
    drag,
  ],
  components: { ArrowHeadSVG },
  props: {
    isOverlay: {
      type: Boolean,
    },
  },
  created() {
    this.hoveredItem = false;
  },
  computed: {
    ...mapFields('visualConnectors', [
      'itemsConnectors',
    ]),
    ...mapFields('nodes', [
      'draggingItem',
      'hoveredItem',
    ]),
    ...mapFields('scale', [
      'layoutScale',
    ]),
    arrowParams() {
      const x = this.layoutScale;
      return {
        width: ARROW_W,
        viewBox: `0 0 ${ARROW_W*2} ${ARROW_W*2}`,
        path: `M 0 0 L ${ARROW_W*2} ${ARROW_W} L 0 ${ARROW_W*2} z`,
      };
    },
  },
  methods: {
    path(item) {
      const {connectorParams, returnToParent} = item;

      if (!connectorParams) {
        return false;
      }

      const {
        aX,
        aY,
        bX,
        bY,
      } = connectorParams;

      const marginX = {
        left: returnToParent ? ARROW_W : 0,
        right: ARROW_W,
      };

      const h = Math.abs(aY - bY);

      let adjustCurveChange = h === 0
        ? 0
        : 2 * h / ADJUST_CURVE_MAX;
      if (adjustCurveChange < 0) {
        adjustCurveChange = 0;
      }
      let adjustCurveLeft = ADJUST_CURVE_MAX - adjustCurveChange;
      if (adjustCurveLeft < 1) {
        adjustCurveLeft = 1;
      }
      let adjustCurveChangeR = h === 0
        ? 0
        : 2 * Math.pow(h, 1.25) / ADJUST_CURVE_MAX;
      let adjustCurveRight = ADJUST_CURVE_MAX / 4 + adjustCurveChangeR;
      if (adjustCurveRight < 8) {
        adjustCurveRight = 8;
      }
      if (adjustCurveRight > ADJUST_CURVE_MAX * 1.05) {
        adjustCurveRight = ADJUST_CURVE_MAX * 1.05;
      }

      // console.log(`h: ${h}, adjustCurveChange: ${adjustCurveChange}, adjustCurveLeft: ${adjustCurveLeft}, adjustCurveRight: ${adjustCurveRight}`);

      return `M ${aX + marginX.left},${aY} C ${aX + adjustCurveLeft + marginX.left},${aY} ${bX - adjustCurveRight - marginX.right}, ${bY} ${bX - marginX.right}, ${bY}`;
    },
    pathStyle(item) {
      return {
        cursor: this.isOverlay && 'pointer',
        stroke: this.isOverlay
          ? this.hoveredItem === item.from
            ? 'transparent'
            : 'transparent'
          : 'black',
        'stroke-width': !this.isOverlay
          ? this.layoutScale
          : this.layoutScale * 5,
      };
    },
    showAddMenu(item) {
      eventBus.$emit('showAddMenu', item);
    },
  },
};
</script>
